const BOOK_STATUS = {
  IN_PROGRESS: 'in progress',
  COMPLETE: 'complete',
};

export default BOOK_STATUS;
